// Get the most recent job, via the last element of the job entities map.
const getPrimaryJob = (state) =>
    Object.values(state.entities.jobs).slice(-1)[0] || {};

export const getJobDetails = (state) => {
    const primaryJob = getPrimaryJob(state);
    const companyName = primaryJob.company ? primaryJob.company.name : '';
    return {
        uuid: primaryJob.uuid,
        companyUuid: primaryJob.company ? primaryJob.company.uuid : '',
        companyName,
        payCycleDescription: (primaryJob.payCycleDescription || '').split(
            ',',
        )[0],
        payCycle: primaryJob.payCycle || '',
        supportsDecimalDirectDeposits: primaryJob.company
            ? !primaryJob.company.roundToDollar
            : true,
        // NOTE: We keep the "full paycheck" name here to avoid having to migrate backend data
        perpaySplitEligible: primaryJob.payrollProviderType === 'full_paycheck',
        isGigEconomyCompany: primaryJob.isGigEconomyCompany,
        deductionIntegrationType: primaryJob.deductionIntegrationType,
    };
};

export const getIsPerpaySplitEligible = (state) =>
    getJobDetails(state).perpaySplitEligible;

export const getCompanyUnverified = (state) => {
    const primaryJob = getPrimaryJob(state);
    return primaryJob.company ? !primaryJob.company.verified : false;
};

const getDeductionIntegrationType = (state) =>
    getJobDetails(state).deductionIntegrationType;

const DEDUCTION_INTEGRATION_TYPE_PAYCHEX = 'paychex';
// const DEDUCTION_INTEGRATION_TYPE_MANUAL = 'manual'; // TODO: uncomment when needed
// const DEDUCTION_INTEGRATION_TYPE_PINWHEEL = 'pinwheel'; // TODO: uncomment when needed

export const getIsPayrollPaymentSetupUser = (state) => {
    const deductionIntegrationType = getDeductionIntegrationType(state);

    return deductionIntegrationType === DEDUCTION_INTEGRATION_TYPE_PAYCHEX;
};
